/** "normal" loading state */
export default 1;
